import React from "react";
import { COLORS } from "../constants/colors";
import Seo from "../components/Seo";
import "./PrivacyPolicy.css";

function PrivacyPolicyR() {
  const lastUpdated = "26 April 2026";

  return (
    <div className="policy-container">
      <Seo
        title="Privacy Policy — RozHisaab (RozHisaab–Expense & Khata Book)"
        description="Privacy policy for RozHisaab ,RozHisaab–Expense & Khata Book — how we collect and use data."
      />

      <section className="policy-header">
        <h1 style={{ color: COLORS.primary }}>Privacy Policy</h1>
        <p className="updated">
          <strong>Last updated:</strong> {lastUpdated}
        </p>
      </section>

      <section className="policy-content">
        <p>
          RozHisaab , RozHisaab–Expense & Khata Book ("we", "our", "us") is a business tracking application that
          helps users manage daily Kharch (expenses) and Bikri (sales). Your
          privacy is very important to us.
        </p>

        <h2>Information We Collect</h2>
        <ul>
          <li>Mobile number for account authentication</li>
          <li>User-provided Kharch (expense) and Bikri (sales) data</li>
          <li>Basic device information for performance and security</li>
        </ul>

        <h2>How We Use Your Information</h2>
        <ul>
          <li>To authenticate users securely</li>
          <li>To store and manage business data</li>
          <li>To generate daily, weekly, monthly reports</li>
          <li>To improve app experience</li>
        </ul>

        <h2>Data Security</h2>
        <p>
          We follow industry-standard practices to protect your data. We do not
          sell or share your personal information with third parties.
        </p>

        <h2>Third-Party Services</h2>
        <p>
          We may use trusted third-party services (like cloud or analytics) only
          to support app functionality. These services handle data according to
          their own privacy policies.
        </p>

        <h2>User Rights</h2>
        <p>
          You can request account deletion or data removal anytime by contacting
          us.
        </p>

        <h2>Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy when needed. Any changes will be
          updated on this page.
        </p>

        <h2>Contact Us</h2>
        <p>
          For any questions, contact us at:
          <br />
          <strong>Email:</strong>{" "}
          <a href="mailto:budgetmate1.app@zohomail.in">
            budgetmate1.app@zohomail.in
          </a>
        </p>
      </section>
    </div>
  );
}

export default PrivacyPolicyR;